export default "__VITE_ASSET__Q2B5sbWD__"